import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { Observable } from 'rxjs'
import { environment } from 'src/environments/environment'

const BASE_URL = environment.BASE_URL + 'historicalpricing/'

@Injectable({
  providedIn: 'root',
})
export class PricingService {
  private http = inject(HttpClient);

  getPS1(id: string): Observable<any> {
    const url = `${BASE_URL}getps1?ps1_id=${id}`;
    const res = this.http.get(url);
    return res;
  }

  getQuotePS1(id: string): Observable<any> {
    const url = `${BASE_URL}sfdc_quotes_ps1?ps1_id=${id}`;
    const res = this.http.get(url);
    return res;
  }

  getAP9(id: string): Observable<any> {
    const url = `${BASE_URL}getap9?ap9_id=${id}`;
    const res = this.http.get(url);
    return res;
  }

  getQuoteAP9(id: string): Observable<any> {
    const url = `${BASE_URL}sfdc_quotes_ap9?ap9_id=${id}`;
    const res = this.http.get(url);
    return res;
  }

  getLastUpdatedDate(): Observable<any> {
    const url = `${BASE_URL}get-last-updated-date`;
    const res = this.http.get(url);
    return res;
  }

  getHistoricalQuotes(orderId: string, itemId: string): Observable<any> {
    const url = `${BASE_URL}order?order_id=${orderId}&item_id=${itemId}`;
    const res = this.http.get(url);
    return res;
  }

}
